import React, {useEffect} from 'react';
import { Routes,Route} from 'react-router-dom';
import Front from './Front';
import About from './About';
import FAQ from './FAQ';
import PeerReview from './PeerReview';

export default function App(){
return(
   
   <Routes>
      <Route  path="/" element={<Front/>}/>
      <Route  path="/about" element={<About/>}/>
      <Route  path="/faq" element={<FAQ/>}/>
       {/* <Route  path="/peer-review" element={<PeerReview/>}/> */}
   </Routes>
 );
}